import { useState, useEffect, useRef, useMemo } from 'react';
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';
import { useSelector, useDispatch } from 'react-redux';
import { getLeadEmailTemplates, updateTemplateNote, updateLeadDetailsInStore, downloadTemplatePdf } from '@src/store/slices/insurance';
import FullPageLoader from '@common/FullPageLoader';
import * as HELPER from "../../../../config/helper";
import { ROLE_FEATURES, PHILIPPINE_CURRENCY, CURRENCY_SYMBOL, STATUS_SUB_STATUS, DEALER_PRESENT_NO, DEALER_PRESENT_YES, APP_TYPE_STANDALONE, APP_TYPE_RENEWAL,COUNTRY_CODE,INS_INSURANCE_ID_STAGE, STATUS_SUCCESS, TEMPLATE_TYPE_BROKER, TEMPLATE_TYPE_POLICY_SHARED } from "@src/config/constant";
import { useLanguage } from '@src/context/LanguageContext';
const PesoImage =  require('../../../../styles/webroot/images/philippine-peso.png');

const EmailTemplateView = (props: any) => {
    
    const [templateData, setTemplateData] = useState("");
    const [whtsApptemplateData, setWhtsApptemplateData] = useState("");
    const [descriptionData, setDescriptionData] = useState<any>([]);
    const dispatch: any = useDispatch();
    const {translations} = useLanguage();

    const [loading, setLoading] = useState(false);

    const insuranceState = useSelector((state: any) => state.insurance);
    const isBrokerSent = useSelector((state: any) => state.insurance?.isBrokerSent);

    const [triggerTemplateData, setTriggerTemplateData] = useState(true);
    const lastFetchedBranchIdRef = useRef<number>(0);

    const [notesValue, setNotesValue] = useState({ templateType: "", note: "" });

    const contentRef = useRef(null);

    const [emailNoteValue, setemailNoteValue] = useState("");
    const [whatsappNoteValue, setWhatsappNoteValue] = useState("");

    const [emailNoteEditable, setEmailNoteEditable] = useState(false);
    const [whatsappNoteEditable, setWhatsappNoteEditable] = useState(false);
    const templateFor:number = props.templateType === "broker" ? TEMPLATE_TYPE_BROKER : TEMPLATE_TYPE_POLICY_SHARED;
    const sharedBranchId = insuranceState?.leadDetail?.sharedTemplateData?.find((row:any)=>row.type === templateFor && row.branch_id!==0)?.branch_id || 0;
    const branchId = props.selectedBranchId || sharedBranchId || insuranceState?.leadDetail?.branch_id;
    const [existingDesc, setExistingDesc] = useState<any>([]);

    const getBranchFilteredTemplates = (templates: any[] = []) => {
        if (COUNTRY_CODE !== 'id' || props.templateType !== "broker") return templates;
        return templates?.filter?.((item: any) => +item?.branch_id === +branchId) || [];
    };

    // Process template data when descriptionData changes
    useEffect(() => {
        processTemplateData();
        // eslint-disable-next-line
    }, [descriptionData,translations]);

    // For ID broker flow, refetch templates when branch changes
    useEffect(() => {
        if (COUNTRY_CODE !== 'id' || props.templateType !== "broker") return;
        if (!insuranceState?.leadDetail?.partner_id) return;

        const selectedBranchId = +branchId || 0;
        if (!selectedBranchId) return;

        // Avoid duplicate calls for same branch
        if (+lastFetchedBranchIdRef.current === selectedBranchId && !triggerTemplateData) return;
        lastFetchedBranchIdRef.current = selectedBranchId;

        setLoading(true);
        const leadEmailObj: any = { leadId: insuranceState?.leadDetail?.leadId, branch_id: selectedBranchId };
        dispatch(getLeadEmailTemplates(leadEmailObj))
            .then(() => {
                setTriggerTemplateData(false);
                setLoading(false);
            })
            .catch(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [branchId, props.templateType, insuranceState?.leadDetail?.partner_id]);


    // Set the Email and WhatsApp template Type for different templateFor like  Sent to Insurance Broker(1) and Insurance Policy Shared(2)
    const processTemplateData = () => {

        if (descriptionData && descriptionData.length > 0) {
            const matchingTemplateType = props.templateType === "broker" ? 1 : 2;

            // Find the email and WhatsApp templates template_type = 1 is for email, template_type =2 is for whstapp
            const emailTemplate = descriptionData.find((item: any) =>
                +item.template_type === 1 && +item.template_for === +matchingTemplateType
            );
            
            let whatsappTemplate:any;
            if(INS_INSURANCE_ID_STAGE)
            {
                whatsappTemplate = descriptionData.find((item: any) =>
                    +item.template_type === 2 && +item.template_for === +matchingTemplateType
                );
            }else{
                whatsappTemplate = descriptionData.find((item: any) =>
                    +item.template_type === 2 && +item.template_for === +matchingTemplateType
                );
            }    

            if (emailTemplate) {
                let emailDescription = emailTemplate?.description;
                if(COUNTRY_CODE==='ph'){
                    emailDescription = emailTemplate?.description?.replaceAll('\n', '<br/>');
                }
                if(+matchingTemplateType===1 && (COUNTRY_CODE==='id')){
                    emailDescription = emailTemplate?.description
                }
                setTemplateData(emailDescription);
                setemailNoteValue(emailTemplate?.note);
                // Update parent state
                props.setEmailTemplateExists(true);
            } else {
                setTemplateData("");
                setemailNoteValue("");
                // Update Parent State
                props.setEmailTemplateExists(false);

            }
            if (whatsappTemplate) {
                let whatsappDescription;
                if(COUNTRY_CODE==='id'){
                    // whatsappDescription = whatsappTemplate?.description?.replaceAll('\n', '<br/>');
                    whatsappDescription = whatsappTemplate?.description;

                }else{
                    whatsappDescription = whatsappTemplate?.description;
                }
                if(+matchingTemplateType===1){
                  //  whatsappDescription = whatsappTemplate?.description
                }
                setWhtsApptemplateData(whatsappDescription);
                setWhatsappNoteValue(whatsappTemplate?.note);
                // Update Parent State
                props.setWhatsappTemplateExists(true)

            } else {
                setWhtsApptemplateData("");
                setWhatsappNoteValue("");
                // Update Parent State
                props.setWhatsappTemplateExists(false)

            }
        } else {
            setTemplateData("");
            setWhtsApptemplateData("");
            setemailNoteValue("");
            setWhatsappNoteValue("");
            props.setEmailTemplateExists(false);
            props.setWhatsappTemplateExists(false);
        }
    };

    useEffect(() => {
        let waTempData = whtsApptemplateData;
        if(whatsappNoteValue){
            waTempData += "<br/><br/>Note: "+whatsappNoteValue;
        }
        props.setTemplateData(waTempData);
        // eslint-disable-next-line
    }, [whtsApptemplateData, whatsappNoteValue])

    // Fetch description data based on the templateType prop

    useEffect(() => {
        const templateFor = props.templateType === "broker" ? 1 : 2;
        let sendBrokercheckFromApiCall = true;
        let policySharedcheckFromApiCall = true;
        //CHECK FOR SEND TO BROKER 
        if((insuranceState?.leadDetail?.status_id >= STATUS_SUB_STATUS['status']['sent_to_insurance_broker'] && props.templateType === "broker") && insuranceState?.leadDetail?.sharedTemplateData?.length){
            let filteredDescriptionData:any;
            if(INS_INSURANCE_ID_STAGE){
                filteredDescriptionData = insuranceState?.leadDetail?.sharedTemplateData?.filter((item: any) => item.type === templateFor);

            }else{
                filteredDescriptionData = insuranceState?.leadDetail?.sharedTemplateData?.filter((item: any) => item.type === templateFor);
            }
            //IF DATA FOUND WITH DESCRIPTION 
            if(filteredDescriptionData.length && filteredDescriptionData[0] && filteredDescriptionData[0]['template_text']){
                
                filteredDescriptionData = filteredDescriptionData.map((template: any) => { return { "template_type": template.source, "template_for": template.type, description: template.template_text, note: template?.note , is_details_sent: template.is_details_sent,language:template.language,branch_id:template.branch_id||0} });
                filteredDescriptionData = getBranchFilteredTemplates(filteredDescriptionData);
                setDescriptionData([...filteredDescriptionData]);
                sendBrokercheckFromApiCall = false;
            }

        }
        //CHECK FOR POLICY SHARE 
        if((insuranceState?.leadDetail?.status_id >= STATUS_SUB_STATUS['status']['insurance_policy'] && props.templateType === "customer") && insuranceState?.leadDetail?.sharedTemplateData?.length && insuranceState?.leadDetail?.sharedTemplateData[0] && insuranceState?.leadDetail?.sharedTemplateData[0]['template_text']){
            let filteredDescriptionData:any;
            if(INS_INSURANCE_ID_STAGE){     
                filteredDescriptionData = insuranceState?.leadDetail?.sharedTemplateData?.filter((item: any) => item.type === templateFor);

            }else{
                filteredDescriptionData = insuranceState?.leadDetail?.sharedTemplateData?.filter((item: any) => item.type === templateFor);
            }
            //IF DATA FOUND WITH DESCRIPTION 
            if(filteredDescriptionData.length && filteredDescriptionData[0] && filteredDescriptionData[0]['template_text']){
                filteredDescriptionData = filteredDescriptionData.map((template: any) => { return { "template_type": template.source, "template_for": template.type, description: template.template_text, note: template?.note , is_details_sent: template.is_details_sent,language:template.language,branch_id:template.branch_id||0} });
                filteredDescriptionData = getBranchFilteredTemplates(filteredDescriptionData);
                setDescriptionData([...filteredDescriptionData]);
                policySharedcheckFromApiCall = false;
            }
        }
        //IF PRESAVED DATA FOUND THEN CALL API DATA
        if((policySharedcheckFromApiCall && props.templateType === "customer") || (sendBrokercheckFromApiCall && props.templateType === "broker")){ //IF NOT SHARED YET

            let checkDealerPresent = (COUNTRY_CODE==='ph' && [APP_TYPE_STANDALONE, APP_TYPE_RENEWAL].includes(insuranceState.leadDetail.application_type_id)) ? (insuranceState.leadDetail.other_detail_dealer_id ? DEALER_PRESENT_YES : DEALER_PRESENT_NO) : null;
            const selectedLanguage = translations.commonMsg?.['language'] || translations.commonMsg?.loading;
            const templateConfigData = insuranceState.leadTemplateData?.filter((item: any) => {
                const isMatchingTemplate = item.template_for === templateFor && item.dealer_present === checkDealerPresent;
                if(INS_INSURANCE_ID_STAGE){
                    return isMatchingTemplate && item.language === selectedLanguage;
                }
                return isMatchingTemplate;
            }) || [];

            if (templateConfigData.length) {
                let filteredDescriptionData: any = [];
                let checkFromState = false;
                if (insuranceState?.leadDetail?.sharedTemplateData?.length) {
                    //FILTER FROM SAVED RECORD FOR NOT  MAPPING
                    filteredDescriptionData = insuranceState?.leadDetail?.sharedTemplateData?.filter((item: any) => item.type === templateFor);

                    filteredDescriptionData = filteredDescriptionData.map((template: any) => { return { "template_type": template.source, "template_for": template.type, description: template.template_text, note: template?.note , is_details_sent: template.is_details_sent,language:template.language,branch_id:template.branch_id||0} });
    
                    if (!filteredDescriptionData.length) {
    
                        checkFromState = true;
    
                    } else {
                        //ELSE PICK DATA FROM TEMPLATE INFO DATA
                        let finalArray = [];
    
                        let templateConfigStateData = JSON.parse(JSON.stringify(filteredDescriptionData));
                        

                        let getTemplatesFromCnfig = JSON.parse(JSON.stringify(templateConfigData));
    
    
                        for (let configTemplate of getTemplatesFromCnfig) {
    
                            let getSavedTemplateData = templateConfigStateData.find((savedTemp: any) => +savedTemp.template_type === +configTemplate.template_type);
    
                            if (getSavedTemplateData) {
                                if(!getSavedTemplateData.description){
    
                                    getSavedTemplateData = { ...getSavedTemplateData, ...configTemplate }
                                    
                                    getSavedTemplateData['template_text'] = getSavedTemplateData?.description || ""
                                    getSavedTemplateData['description'] = getSavedTemplateData?.description || configTemplate['description']
                                    getSavedTemplateData['note'] = getSavedTemplateData.note || ""
                                    getSavedTemplateData['language'] = getSavedTemplateData.language || ""
                                }
    
                            } else {
                                getSavedTemplateData = { 'template_text': getSavedTemplateData?.template_text || "" }
    
                                getSavedTemplateData = { ...getSavedTemplateData, ...configTemplate }
    
                            }
    
                            finalArray.push(getSavedTemplateData)
                        }
    
    
                        filteredDescriptionData = finalArray
    
                    }
                } else {
                    checkFromState = true;
                }
    
                if (checkFromState) {
                    filteredDescriptionData = templateConfigData;

                }
                if(COUNTRY_CODE==='id'){
                    setExistingDesc([...filteredDescriptionData]);
                    filteredDescriptionData = getBranchFilteredTemplates(filteredDescriptionData);
                }
                setDescriptionData([...filteredDescriptionData]);
    
            } else {
    
                if (insuranceState?.leadDetail?.partner_id && triggerTemplateData && !(COUNTRY_CODE === 'id' && props.templateType === "broker")) {
    
                    setLoading(true);
                    
                    let leadEmailObj:any={leadId:insuranceState?.leadDetail?.leadId};
                    if(COUNTRY_CODE!=='id'){
                        leadEmailObj.partner_id= +insuranceState?.leadDetail?.partner_id;
                    }
                    if (branchId && props?.templateType!=='customer') {
                        leadEmailObj.branch_id = +branchId;
                    }
                        
                    dispatch(getLeadEmailTemplates(leadEmailObj))
                        .then((res: any) => {
                            setTriggerTemplateData(false)
                            setLoading(false);
    
                        }).catch((err: any) => setLoading(false));
                }
            }
        }
        // eslint-disable-next-line
    }, [props.templateType, insuranceState.leadDetail.partner_id, insuranceState.leadTemplateData,translations,branchId]);



    const saveNoteData = (e: any, key: any, val: any) => {
        e.stopPropagation();
        let source;
        let type;
        // here  Source => 1: email, 2: whstapp
        val === 'email' ? source = 1 : source = 2;
        // here type => 1: broker, 2: policy, 
        key === 'broker' ? type = 1 : type = 2;

        if(notesValue?.note && notesValue?.note?.trim()){

            setLoading(true);
            updateTemplateNote({ newNote: notesValue?.note, leadId: insuranceState?.leadDetail?.leadId, source: source, type: type })
            .then((res: any) => {
                setTriggerTemplateData(false)
                setLoading(false);
                dispatch(updateLeadDetailsInStore({ ...insuranceState.leadDetail, sharedTemplateData: res.data }));
                // after submit input filed hide
                if (val === 'email') {  
                    setEmailNoteEditable(false);
                }
                else if (val === 'whatsApp') {
                    props.setTemplateData(whtsApptemplateData+"<br/><br/>Note: "+notesValue?.note)
                    setWhatsappNoteEditable(false);
                }
                
                
                
            }).catch((err: any) => setLoading(false));
        }else{
            
            setEmailNoteEditable(false);
            setWhatsappNoteEditable(false);
            setNotesValue({ templateType:"", note:"" });
            setemailNoteValue("")
            setWhatsappNoteValue("");

        }
    }

    const handleInputChange = (templateType: string, note: any) => {
        setNotesValue({ templateType, note })
        if (templateType === "email") {
            setemailNoteValue(note)
        } else {
            setWhatsappNoteValue(note);
        }
    }

    const editNote = (templateType: string) => {
        // if template is email and whstapp then edit field show
       if(templateType === "email"){
        setEmailNoteEditable(true);
       }
       else if(templateType === "whatsApp"){
        setWhatsappNoteEditable(true);
       }
       else{
        setEmailNoteEditable(true);
        setWhatsappNoteEditable(false);
       }
    }

    const generatePDF = (e: any, templateType: any, templateFor: any) => {
        e.stopPropagation();

        setLoading(true)

        let combinedContent = "";

        if (templateFor === "email") {

            combinedContent = `${templateData}`;
            combinedContent.replaceAll(`&#8369;`, '₱')
            if(emailNoteValue){
                combinedContent += `<br/><br/>Note: ${emailNoteValue || ""}`;
            }

        }
        if (templateFor === "whatsapp") {

            combinedContent = `${whtsApptemplateData}`;
            combinedContent.replaceAll(`&#8369;`, '₱')

            if(whatsappNoteValue){
                combinedContent += `<br/><br/>Note: ${whatsappNoteValue || ""}`;
            }
        }

        let fileName = insuranceState?.leadDetail?.leadId;
        fileName += "-"+((templateType === "broker") ?  `${templateFor}-send-to-broker.pdf` : `${templateFor}-policy-shared.pdf`);

        if(COUNTRY_CODE!=='id'){
            combinedContent = combinedContent.replaceAll(CURRENCY_SYMBOL, `<img src="${PesoImage}" alt="currency-image" style="width:10px"/>`);
            combinedContent = combinedContent.replaceAll(PHILIPPINE_CURRENCY, `<img src="${PesoImage}" alt="currency-image" style="width:10px"/>`);
        }
        
        downloadTemplatePdf({html:combinedContent, name: fileName, lead_id: insuranceState?.leadDetail?.leadId}).then((resp:any)=>{
            if(resp.status===STATUS_SUCCESS && resp?.data?.link){
                window.open(resp.data.link, '_blank')
            }

            setLoading(false)
        }).catch((err: any) => {
            setLoading(false)
        })

       

    };

  
    const setTemplate = async() => {
        try {
           
            const templateType:number = props.templateType === "broker" ? TEMPLATE_TYPE_BROKER : TEMPLATE_TYPE_POLICY_SHARED;
            const selectedLanguage = translations.commonMsg?.['language'];
            let data = existingDesc?.filter((item: any) => 
                +item.template_for === +templateType 
                && (!selectedLanguage || item.language===selectedLanguage)
                && +branchId === +item.branch_id
            );
            if (!data?.length) {
                data = existingDesc?.filter((item: any) => +item.template_for === +templateType && +branchId === +item.branch_id);
            }
           
            setDescriptionData(data);
            
            const isEmailData:Record<string,any> = data?.find((item: any) => +item.template_type === 1); 
            const isWhatsappData:Record<string,any> = data?.find((item: any) => +item.template_type === 2);
            if(isEmailData){
                props?.setEmailTemplateExists(true);
                setTemplateData(isEmailData?.description);
            }else{
                setTemplateData("");
                props?.setEmailTemplateExists(false);
            }
            if(isWhatsappData){
                setWhtsApptemplateData(isWhatsappData?.description);
                props?.setWhatsappTemplateExists(true);
            }else{
                setWhtsApptemplateData("");
                props?.setWhatsappTemplateExists(false);
            }
        } catch (error) {}
    }
    
    const brokerSentData = useMemo(() => {
    return insuranceState?.leadDetail?.sharedTemplateData
        ?.filter((item: any) => item.type === TEMPLATE_TYPE_BROKER) || [];
    }, [insuranceState?.leadDetail?.sharedTemplateData]);  

    useEffect(() => {
        if (branchId && COUNTRY_CODE==='id' && props.templateType === "broker" && brokerSentData.length===0 && !isBrokerSent) {
           setTemplate()
        }
    }, [branchId, existingDesc, props.templateType, brokerSentData.length, isBrokerSent, translations, props.activeTab]);

    return (

        <div className="image-tab-panel emailer-outer">
            <FullPageLoader show={loading} />

            <div className="email-templete-sec financer-email-popup">
                <div className="heading-icn">
                    <h3>{translations.Insurance?.['Email'] || translations.commonMsg?.loading} | {translations.Insurance?.['Whatsapp'] || translations.commonMsg?.loading} - {props.templateType === "broker" ? `${translations.Insurance?.['Sent to Insurance Broker'] || translations.commonMsg?.loading}` : `${translations.Insurance?.['Insurance Policy Shared'] || translations.commonMsg?.loading}` }</h3>

                </div>
                <div className="lead-form-filed send-financer">

                    <div className="financer-doc-list">
                        <Accordion allowZeroExpanded>

                            {
                                templateData &&
                                <AccordionItem >
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                        {translations.Insurance?.['Email'] || translations.commonMsg?.loading} <i className="ic-save_alt template-download-icon" onClick={(e: any) => generatePDF(e, props.templateType, 'email')}></i>
                                        </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>

                                        <>

                                            <div className=''>
                                                
                                            <div ref={contentRef} id="emailPdfGenreator" className="financer-email-data" dangerouslySetInnerHTML={{ __html: templateData }} />

                                                <div className='d-flex p-lg'>

                                                    <div className={`email-note-text ${emailNoteEditable ? 'note-edit-option w-100' : 'd-flex' }`} >
                                                        {
                                                            emailNoteEditable
                                                                ?
                                                                (
                                                                    <>
                                                                        <fieldset className="form-filed w-100">
                                                                            <span className='p-sm-r nowrap'>Note :</span>
                                                                            <div className="material w-100">
                                                                                <textarea id="description" placeholder=" " name="note" className="form-input" value={emailNoteValue} onChange={(e) => handleInputChange('email', e.target.value)} />
                                                                                <span className='note-check m-sm-l' onClick={(e) => { saveNoteData(e, props.templateType, 'email') }}> <i className="ic-check"></i> </span>
                                                                            </div>
                                                                        </fieldset>

                                                                    </>
                                                                )
                                                                :
                                                                <>
                                                                    <span className='nowrap'>{translations.commonMsg?.['Note'] || translations.commonMsg?.loading}: </span> 
                                                                    { emailNoteValue && <span className='d-flex p-md-l longtext' > {emailNoteValue || ""} </span> }                                                               
                                                                </>
                                                        }

                                                    </div>

                                                    {
                                                        HELPER.isUserHasUpdateAccess({ permissionID: (props.templateType === "broker" ? ROLE_FEATURES['send_to_insurance_broker'] : ROLE_FEATURES['insurance_policy_shared']), accessType: 'edit', leadDetails: insuranceState.leadDetail, pageSlug: (props.templateType === "broker" ? "sent_to_insurance_broker" : "policy_shared") }) && !emailNoteEditable &&

                                                        <div className={`note-edit-icn ${emailNoteValue ? 'm-md-l' : ''}`} onClick={() => editNote('email')}><i className="ic-edit pointer"></i></div>

                                                    }
                                               
                                               </div>

                                            </div>
                                        </>
                                        {

                                        }
                                    </AccordionItemPanel>
                                </AccordionItem>
                            }

                            {
                                whtsApptemplateData &&

                                <AccordionItem >
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                        {translations.Insurance?.['Whatsapp'] || translations.commonMsg?.loading} <i className="ic-save_alt template-download-icon" onClick={(e: any) => generatePDF(e, props.templateType, 'whatsapp')}></i>                                        </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>

                                        <>
                                            <div className=''>
                                                <div ref={contentRef} className="financer-email-data" dangerouslySetInnerHTML={{ __html: whtsApptemplateData }} />

                                                <div className='d-flex p-lg'>

                                                    <div className={`email-note-text ${whatsappNoteEditable ? 'note-edit-option w-100' : 'd-flex' }`} >
                                                        {
                                                            whatsappNoteEditable
                                                                ?
                                                                (
                                                                    <>
                                                                        <fieldset className="form-filed w-100">
                                                                            <span className='p-sm-r nowrap'>{translations.commonMsg?.['Note'] || translations.commonMsg?.loading} :</span>
                                                                            <div className="material w-100">
                                                                                <textarea id="description" placeholder=" " name="note" className="form-input" value={whatsappNoteValue} onChange={(e) => handleInputChange('whatsApp', e.target.value)} />
                                                                                <span className='note-check m-sm-l' onClick={(e) => { saveNoteData(e, props.templateType, 'whatsApp') }}> <i className="ic-check"></i> </span>
                                                                            </div>
                                                                        </fieldset>

                                                                    </>
                                                                )
                                                                :
                                                                <>
                                                                    <span className='nowrap'>{translations.commonMsg?.['Note'] || translations.commonMsg?.loading}: </span> 
                                                                    { whatsappNoteValue && <span className='d-flex p-md-l longtext'> {whatsappNoteValue || ""} </span> }
                                                                </>
                                                        }

                                                    </div>

                                                    
                                                    {
                                                        HELPER.isUserHasUpdateAccess({ permissionID: (props.templateType === "broker" ? ROLE_FEATURES['send_to_insurance_broker'] : ROLE_FEATURES['insurance_policy_shared']), accessType: 'edit', leadDetails: insuranceState.leadDetail, pageSlug: (props.templateType === "broker" ? "sent_to_insurance_broker" : "policy_shared") }) && !whatsappNoteEditable && <div className={`note-edit-icn ${whatsappNoteValue ? 'm-md-l' : ''}`} onClick={() => editNote('whatsApp')}><i className="ic-edit pointer"></i></div>
                                                    }
                                                </div>
                                                
                                            </div>

                                        </>


                                    </AccordionItemPanel>
                                </AccordionItem>
                            }

                        </Accordion>
                    </div>
                </div>
            </div>
        </div>

    );
};


export default EmailTemplateView;
